import { NotificationBanner as NotificationBannerComponent } from '@almbrand/notificationbanner';
import { useThemeName } from 'hooks/useThemeName';
import { useState } from 'react';

export const NotificationBanner: React.FC<NotificationReference> = ({ richText, backgroundColor, contentId }) => {
	const sessionKey = `close-notification-banner-${contentId}`;
	const themeName = useThemeName();
	const [displayBanner, setDisplayBanner] = useState(!sessionStorage.getItem(sessionKey));

	const onBannerClose = () => {
		sessionStorage.setItem(sessionKey, 'true');
		setDisplayBanner(false);
		window.dispatchEvent(new Event('notification-banner-closed'));
	};

	return (
		displayBanner && (
			<NotificationBannerComponent
				content={richText}
				themeName={themeName}
				iconProps={{ icon: 'warning_thin' }}
				backgroundColor={
					backgroundColor?.cssClass.includes('bg-navy') ? 'bg-notification' : backgroundColor?.cssClass
				}
				onClose={onBannerClose}
			/>
		)
	);
};
